import gql from 'graphql-tag';

export const getQuizListing = gql`query{
    getQuizListing(first: 1) {
        edges {
            node {
                id,
                title,
                description,
                image {
                    fullpath
                },
                questions {
                    ... on object_QuizQuestion {
                        Question,
                        anwsers {
                            ... on fieldcollection_QuizAnswer {
                                answer,
                                correctAnswer,
                                uniqueId
                            }
                        }
                    }
                }
            }
        }
    }
}`;
